module.exports = __webpack_public_path__ + "media/src/pages/GuidedOnboarding/images/fileCheckYellow-d3e17ed56f0c187e0f2d72aa73e07b38.png";